import TeacherStatusTag from './TeacherStatusTag';
import { TeacherStatusTagProps, TeacherStatusTagValueProps } from './types';

export type { TeacherStatusTagProps, TeacherStatusTagValueProps };
export default TeacherStatusTag;
